import React from 'react';
import * as PropTypes from 'prop-types';

import { Spacer } from './elements';

function Spa24(props) {
  return <Spacer className={props.className} />;
}

Spa24.propTypes = {
  className: PropTypes.string,
};

export default Spa24;
